import { render } from "./ProductsPolicy.vue?vue&type=template&id=c179bb92"
import script from "./ProductsPolicy.vue?vue&type=script&lang=js"
export * from "./ProductsPolicy.vue?vue&type=script&lang=js"

import "./ProductsPolicy.vue?vue&type=style&index=0&id=c179bb92&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__